import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { ImportProfileButton } from '../ImportProfileButton/ImportProfileButton.js';
export const ImportProfileButtonsContainer = ({ onModalClose, }) => {
    const { t } = useTranslation();
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceM'], children: [_jsx(ImportProfileButton, {}), _jsx(Button, { "data-testid": "maybe-later-button", a11yLabel: "Maybe later button", variant: "secondary", onClick: onModalClose, isFullWidth: true, isLoading: false, children: t('loginregistration.linkedIn.importProfile.laterButton') })] }));
};
//# sourceMappingURL=ImportProfileButtonsContainer.js.map